
import { computed } from '@vue/composition-api';
import { declination } from '@artmizu/utils';
import AvailabilityModal from '~/components/AvailabilityModal/AvailabilityModal.vue';
import type { Availability, OrderDelivery } from '~/type/product/Product';
const __sfc_main = {};
__sfc_main.props = {
  availability: {
    key: "availability",
    required: true,
    type: Array
  },
  delivery: {
    key: "delivery",
    required: true,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const convertText = computed(() => `${props.availability.length} ${declination(props.availability.length, ['магазине', 'магазинах', 'магазинах'])}`);
  const getPickup = computed(() => props.delivery.find(el => el.name === 'Самовывоз'));
  const getDelivery = computed(() => props.delivery.find(el => el.name === 'Курьерская доставка 05.ru'));
  return {
    convertText,
    getPickup,
    getDelivery
  };
};
__sfc_main.components = Object.assign({
  AvailabilityModal
}, __sfc_main.components);
export default __sfc_main;
